import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string; small?: boolean }>`
  background: ${(p) => p.color || "#265389"};
  color: ${(p) => (p.color ? "#265389" : "#fff")};
  font-size: ${(p) => (p.small ? "0.875rem" : "1rem")};
  font-weight: ${(p) => (p.small ? 600 : 700)};
  width: 100%;
  max-width: ${(p) => (p.small ? "140px" : "180px")};
  padding: ${(p) => (p.small ? "6px 12px" : "13px 0")};
  border: 1px solid #edf3f5;
  border-radius: 4px;
  margin-top: ${(p) => (p.small ? "0.3rem" : "0.625rem")};
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  box-shadow: ${(p) =>
    p.small ? "0 8px 16px rgb(23 31 114 / 10%)" : "0 16px 30px rgb(23 31 114 / 20%)"};

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid #8ecce7;
    background-color: #8ecce7;
  }
`;
